import { getSalesType } from "../../../../../actions/Utilities/SalesType";
import { useQuery } from "react-query";

export default function useSalesType() {
  //Fetching SalesType Details
  const {data, isFetching} = useQuery("GetSalesType", getSalesType, {
    refetchOnWindowFocus: false,
  });
  if(data){
    data.sort((a, b) => {
        let fa = a.salesTypeName.toLowerCase(), fb = b.salesTypeName.toLowerCase();
        return (fa < fb)?-1:(fa > fb?1:0);
    });
  }

  return {data, isFetching};
}
